export default {
  getFullDate(timestamp, separator_date = ".", separator_time = ":", separator_full = " ") {
    return `${this.getShortDate(timestamp, separator_date)}${separator_full}${this.getHHMMSS(
      timestamp,
      separator_time
    )}`;
  },

  convertToDate(timestamp, callback) {
    if (isNaN(parseFloat(timestamp)) || !isFinite(timestamp)) {
      console.error("incorrect timestamp format ", timestamp);
      return "&mdash;";
    }
    return callback(new Date(timestamp * 1000));
  },

  getShortDate(timestamp, separator = ".") {
    return this.convertToDate(timestamp, date => {
      let day = date.getDate();
      let month = date.getMonth() + 1;
      let year = date.getFullYear();

      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return `${day}${separator}${month}${separator}${year}`;
    });
  },

  getHHMMSS(timestamp, separator = ":") {
    return this.convertToDate(timestamp, date => {
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      return `${hours}${separator}${minutes}${separator}${seconds}`;
    });
  },

  getDDMM(timestamp, separator = ".") {
    return this.convertToDate(timestamp, date => {
      let day = date.getDate();
      let month = date.getMonth() + 1;

      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      return `${day}${separator}${month}`;
    });
  },
};
